import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/styles";
import { fade, Accordion, AccordionDetails, AccordionSummary, Grid, Icon, Typography } from "@material-ui/core";

import AktyCard from "./AktyCard";

const useStyles = makeStyles((theme) => ({
    AccordionRoot: {
        border: `1px solid ${fade(theme.palette.primary.main, 0.125)}`,
        boxShadow: "none",
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
    },
    expanded: {},
    AccordionSummaryRoot: {
        borderBottom: `1px solid ${fade(theme.palette.primary.main, 0.125)}`,
        marginBottom: -1,
        minHeight: "32px!important",
        "&$expanded": {
            minHeight: 32,
        },
    },
    AccordionSummaryContent: {
        margin: `${theme.spacing(1, 0)}!important`,
    },
    AccordionSummaryContentExpanded: {
        margin: theme.spacing(0, 0),
    },
    AccordionSummaryTitle: {
        fontSize: "0.875rem",
        fontWeight: theme.typography.fontWeightRegular,
    },
    AccordionDetailsRoot: {
        padding: theme.spacing(2),
    },
    card: {
        height: "100%",
    },
    cardHeaderRoot: {
        backgroundColor: fade(theme.palette.primary.main, 0.0675),
    },
    cardHeaderTitle: {
        fontSize: "0.8rem",
        fontWeight: theme.typography.fontWeightMedium,
    },
}));

const AktyAccordion = ({ id_cechy, akty, onExpand }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState("");

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    useEffect(
        () => {
            onExpand();
        },
        // eslint-disable-next-line
        [expanded]
    );

    return (
        <div>
            <Accordion
                square
                expanded={expanded === `cecha-${id_cechy}`}
                onChange={handleChange(`cecha-${id_cechy}`)}
                classes={{ root: classes.AccordionRoot }}
            >
                <AccordionSummary
                    aria-controls={`cecha-${id_cechy}-content`}
                    id={`cecha-${id_cechy}-header`}
                    expandIcon={<Icon>keyboard_arrow_down</Icon>}
                    classes={{
                        root: classes.AccordionSummaryRoot,
                        content: classes.AccordionSummaryContent,
                        expanded: classes.AccordionSummaryContentExpanded,
                    }}
                >
                    <Typography className={classes.AccordionSummaryTitle}>
                        <b>
                            {t("cecha.akty")}
                            <small>({akty.length})</small>:
                        </b>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails classes={{ root: classes.AccordionDetailsRoot }}>
                    <Grid container spacing={1}>
                        {akty.map((akt) => {
                            return (
                                <Grid item xs={12} md={6} key={akt.id_akt}>
                                    <AktyCard akt={akt} noTitle={true} />
                                </Grid>
                            );
                        })}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default AktyAccordion;
